import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TenantBrandingService } from 'src/app/auth/tenant-branding.service';

@Component({
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotfoundComponent implements OnInit {

  appLogoPath: string;

  constructor(private tenantBrandingService: TenantBrandingService) {
    this.appLogoPath = this.tenantBrandingService.getStoredLogoUrl();
  }

  ngOnInit(): void {
    this.tenantBrandingService
      .loadLogoUrl()
      .then(logoUrl => (this.appLogoPath = logoUrl))
      .catch(() => {});
  }

}
